import React from 'react';
import {
    Row,
    Col,
    Typography,
    Statistic,
    Table,
    Avatar,
} from 'antd';
import dayjs from 'dayjs';
import { convertPaymentType, convertDocTypeLabel, backGroundDocType, formatPhone } from '../utils/customFunctions';
import logo from '../assets/tclogo.png'
export default function DocumentForPrint({ docNo, docData, docType, printRef }) {
    // console.log(docType);
    return (
        <div ref={printRef}>
            {['ต้นฉบับ', 'สำเนา', 'บัญชี'].map((textDoc, idx) => <div key={idx} style={{
                background: '#FFF',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column'
            }}

            >
                <div
                    style={{
                        marginBottom: '8px',
                        background: backGroundDocType(docType),
                        padding: '24px'
                    }}>
                    <Row justify='center'>
                        <Col xs={6} >
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div>
                                    <Avatar src={logo} size={120} />
                                </div>
                            </div>
                        </Col>
                        <Col xs={14}>
                            <Typography.Title level={5} style={{ margin: '0px', fontSize: '14px' }}>
                                บริษัท ธงชัย ไอที เซ็นเตอร์ จำกัด
                            </Typography.Title>
                            <Typography.Paragraph style={{ margin: '0px', fontSize: '12px' }}>
                                61/24-25 ตำบล พระปฐมเจดีย์ อำเภอ เมืองนครปฐม จังหวัด นครปฐม 73000
                            </Typography.Paragraph>
                            <Typography.Paragraph style={{ margin: '0px', fontSize: '12px' }}>
                                โทรศัพท์ 034-343149 โทรศัพท์มือถือ {formatPhone('0894114746')}
                            </Typography.Paragraph>
                            {docType === 'TAXINVOICE' && <Typography.Paragraph strong style={{ margin: '0px', fontSize: '12px' }}>
                                เลขประจำตัวผู้เสียภาษี 0735563005627
                            </Typography.Paragraph>}
                        </Col>
                        <Col flex={1} />
                        <Col>
                            <Typography.Paragraph style={{ textAlign: 'right', fontSize: '16px', margin: '0px', padding: '0px' }}>
                                {convertDocTypeLabel(docType).th}
                            </Typography.Paragraph>
                            <Typography.Paragraph style={{ textAlign: 'center', fontSize: '16px', margin: '0px', padding: '0px' }}>
                                {`${convertDocTypeLabel(docType).en}`}
                            </Typography.Paragraph>
                            <div
                                style={{
                                    border: '1px solid #d9d9d9',
                                    textAlign: 'center',
                                    padding: '4px',
                                    borderRadius: '8px'
                                }}
                            >
                                {textDoc}
                            </div>
                        </Col>
                    </Row>
                </div>
                <div style={{ padding: '24px' }}>
                    <Row justify="space-between">
                        <Col xs={16}>
                            <Row>
                                <Col xs={8}>
                                    <Typography.Text strong>
                                        ชื่อลูกค้า
                                    </Typography.Text>
                                </Col>
                                <Col>
                                    <Typography.Text type="secondary">
                                        {`${docData.customer.fname} ${docData.customer.lname}`}
                                    </Typography.Text>
                                </Col>
                            </Row>
                            <Row >
                                <Col xs={8}>
                                    <Typography.Text strong>
                                        สถานที่จัดส่ง
                                    </Typography.Text>
                                </Col>
                                {docData.shipment && <Col>
                                    <Typography.Text type="secondary">
                                        {docData.shipment.address}
                                    </Typography.Text>
                                    <br />
                                    <Typography.Text type="secondary">
                                        {`แขวง/ตำบล${docData.shipment.sub_district} อำเภอ${docData.shipment.district}`}
                                    </Typography.Text>
                                    <br />
                                    <Typography.Text type="secondary">
                                        {`จังหวัด${docData.shipment.province} รหัสไปรษณีย์ ${docData.shipment.postalcode}`}
                                    </Typography.Text>
                                </Col>}
                            </Row>
                            <Row>
                                <Col xs={8}>
                                    <Typography.Text strong>
                                        โทร.
                                    </Typography.Text>
                                </Col>
                                <Col>
                                    <Typography.Text type="secondary">
                                        {formatPhone(docData.customer.phone)}{docData.customer.phone_2 && ` ; ${formatPhone(docData.customer.phone_2)}`}
                                    </Typography.Text>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={8}>
                                    {`เลขประจำตัวผู้เสียภาษี /`}
                                </Col>
                                <Col>
                                    <Typography.Text type="secondary">
                                        {docData.customer.idcard ?? "-"}
                                    </Typography.Text>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Typography.Text strong>
                                        {`เลขที่บัตรประชาชน`}
                                    </Typography.Text>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={8}>
                            <Row justify="end">
                                <Col xs={24}>
                                    <Row justify='space-between'>
                                        <Col >
                                            <Typography.Text strong>
                                                เลขที่{convertDocTypeLabel(docType).th}
                                            </Typography.Text>
                                        </Col>
                                        <Col>
                                            <Typography.Text type="secondary">
                                                {docNo}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row justify="end">
                                <Col xs={24}>
                                    <Row justify='space-between'>
                                        <Col >
                                            <Typography.Text strong>
                                                คำสั่งซื้อเลขที่
                                            </Typography.Text>
                                        </Col>
                                        <Col>
                                            <Typography.Text type="secondary">
                                                {docData.doc_no}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row justify="end">
                                <Col xs={24}>
                                    <Row justify='space-between'>
                                        <Col >
                                            <Typography.Text strong>
                                                วันที่สั่งซื้อ
                                            </Typography.Text>
                                        </Col>
                                        <Col>
                                            <Typography.Text type="secondary">
                                                {dayjs(docData.order_date).format('DD-MM-YYYY')}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row justify="end">
                                <Col xs={24}>
                                    <Row justify='space-between'>
                                        <Col>
                                            <Typography.Text strong>
                                                วันที่ส่งของ
                                            </Typography.Text>
                                        </Col>
                                        <Col>
                                            <Typography.Text type="secondary">
                                                {dayjs(docData.shipment_date).format('DD-MM-YYYY')}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row justify="end">
                                <Col xs={24}>
                                    <Row justify='space-between'>
                                        <Col >
                                            <Typography.Text strong>
                                                วันที่วางบิล
                                            </Typography.Text>
                                        </Col>
                                        <Col>
                                            <Typography.Text type="secondary">
                                                {dayjs(docData.billing_date).format('DD-MM-YYYY')}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row justify="end">
                                <Col xs={24}>
                                    <Row justify='space-between'>
                                        <Col>
                                            <Typography.Text strong>
                                                พนักงานขาย
                                            </Typography.Text>
                                        </Col>
                                        <Col>
                                            <Typography.Text type="secondary">
                                                {docData.employee.fname}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
                <div className='invoice-table-container'>
                    <Row gutter={[0, 24]}>
                        <Col xs={24}>
                            <Table
                                rowKey={(record) => record.id}
                                columns={[
                                    {
                                        title: 'รายการสินค้า',
                                        dataIndex: 'product',
                                        key: 'product',
                                        render: text => `${text?.name} ${text?.brand?.name} ${text?.description ?? ""}`,

                                    },
                                    {
                                        title: 'ราคา',
                                        dataIndex: 'price',
                                        key: 'price',
                                        width: '10%',
                                        render: text => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14, textAlign: 'right' }} />
                                    },
                                    {
                                        title: 'จำนวน',
                                        dataIndex: 'quantity',
                                        key: 'quantity',
                                        width: '10%',
                                        render: text => <Statistic value={text} valueStyle={{ fontSize: 14, textAlign: 'center' }} />
                                    },
                                    {
                                        title: 'ส่วนลดต่อชิ้น',
                                        dataIndex: 'discount',
                                        key: 'discount',
                                        width: '10%',
                                        render: (_, option) => <Statistic value={(option.discount / option.quantity).toFixed(2)} precision={2} valueStyle={{ fontSize: 14, textAlign: 'right' }} />
                                    },
                                    {
                                        title: 'ส่วนลดรวม',
                                        dataIndex: 'discount',
                                        key: 'discount',
                                        width: '10%',
                                        render: text => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14, textAlign: 'right' }} />
                                    },
                                    {
                                        title: 'รวม',
                                        dataIndex: 'total_price',
                                        key: 'total_price',
                                        width: '10%',
                                        render: text => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14, textAlign: 'right' }} />
                                    },
                                ]}
                                dataSource={docData.transaction_items}
                                pagination={false}
                            />
                        </Col>
                    </Row>
                </div>
                <div style={{ flex: 1 }} />
                <div style={{ padding: '24px' }}>
                    <Row justify="space-between" >
                        <Col xs={6} >
                            <Typography.Paragraph
                                strong
                                style={{
                                    margin: '0px',
                                    fontSize: '16px'
                                }}
                            >
                                เพิ่มเติม :
                            </Typography.Paragraph>
                            <Typography.Paragraph
                                style={{
                                    margin: '0px',
                                    fontSize: '14px'
                                }}
                            >
                                {docData.description ?? '-'}
                            </Typography.Paragraph>
                        </Col>
                        <Col xs={6} >
                            <Typography.Paragraph
                                strong
                                style={{
                                    margin: '0px',
                                    fontSize: '16px'
                                }}
                            >
                                ประเภทการชำระสินค้า
                            </Typography.Paragraph>
                            <Typography.Paragraph
                                style={{
                                    margin: '0px',
                                    fontSize: '14px'
                                }}
                            >
                                {convertPaymentType(docData.payment_type)}
                            </Typography.Paragraph>
                        </Col>
                        <Col xs={8} >
                            <Row justify='space-between'>
                                <Col>
                                    <Typography.Paragraph
                                        style={{
                                            margin: '0px',
                                            fontSize: '16px'
                                        }}
                                    >
                                        ราคารวมสินค้า
                                    </Typography.Paragraph>
                                </Col>
                                <Col>
                                    <Statistic
                                        value={docData.total.toFixed(2)}
                                        precision={2}
                                        valueStyle={{
                                            fontSize: '16px',
                                            textAlign: 'center',

                                        }} />
                                </Col>
                            </Row>
                            {/* <Row justify='space-between'>
                                <Col>
                                    <Typography.Paragraph
                                        style={{
                                            margin: '0px',
                                            fontSize: '16px'
                                        }}
                                    >
                                        ส่วนลด
                                    </Typography.Paragraph>
                                </Col>
                                <Col>
                                    <Statistic
                                        value={docData.discount}
                                        precision={2}
                                        valueStyle={{
                                            fontSize: '16px',
                                            textAlign: 'center',

                                        }} />
                                </Col>
                            </Row> */}
                            <Row justify='space-between'>
                                <Col>
                                    <Typography.Paragraph
                                        style={{
                                            margin: '0px',
                                            fontSize: '16px'
                                        }}
                                    >
                                        ภาษีมูลค่าเพิ่ม 7%
                                    </Typography.Paragraph>
                                </Col>
                                <Col>
                                    <Statistic
                                        value={docData.vat.toFixed(2)}
                                        precision={2}
                                        valueStyle={{
                                            fontSize: '16px',
                                            textAlign: 'center',

                                        }} />
                                </Col>
                            </Row>
                            <Row justify='space-between'>
                                <Col>
                                    <Typography.Paragraph
                                        strong
                                        style={{
                                            margin: '0px',
                                            fontSize: '16px'
                                        }}
                                    >
                                        ราคารวมสุทธิ
                                    </Typography.Paragraph>
                                </Col>
                                <Col>
                                    <Statistic
                                        value={docData.grand_total.toFixed(2)}
                                        precision={2}
                                        valueStyle={{
                                            fontSize: '16px',
                                            textAlign: 'center',
                                            fontWeight: 'bold'
                                        }} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
                <div style={{ padding: '24px' }}>
                    <Row justify="end">
                        <Col xs={8}></Col>
                        <Col style={{ marginLeft: '16px', textAlign: 'center' }} xs={4}>
                            <Typography.Paragraph >
                                ผู้รับสินค้า :
                            </Typography.Paragraph>
                            <div style={{ width: '100%', height: '32px' }} />
                            <Typography.Paragraph >
                                -----/-----/-----
                            </Typography.Paragraph>
                        </Col>
                        <Col style={{ marginLeft: '16px', textAlign: 'center' }} xs={4}>
                            <Typography.Paragraph >
                                ผู้ส่งสินค้า :
                            </Typography.Paragraph>
                            <div style={{ width: '100%', height: '32px' }} />
                            <Typography.Paragraph >
                                -----/-----/-----
                            </Typography.Paragraph>
                        </Col>
                        <Col style={{ marginLeft: '16px', textAlign: 'center' }} xs={4}>
                            <Typography.Paragraph >
                                ผู้รับเงิน :
                            </Typography.Paragraph>
                            <div style={{ width: '100%', height: '32px' }} />
                            <Typography.Paragraph >
                                -----/-----/-----
                            </Typography.Paragraph>
                        </Col>
                    </Row>
                </div>
            </div>)}
        </div>
    )
}
